import { render, staticRenderFns } from "./level-update-modal-note.vue?vue&type=template&id=37085a90&scoped=true&"
import script from "./level-update-modal-note.vue?vue&type=script&lang=ts&"
export * from "./level-update-modal-note.vue?vue&type=script&lang=ts&"
import style0 from "./level-update-modal-note.vue?vue&type=style&index=0&id=37085a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37085a90",
  null
  
)

export default component.exports